module.exports = __webpack_public_path__ + "e5eb0613bea38b4fff7d7fec270235c6.svg";